<template>
    <v-container fluid fill-height>
      <v-layout align-center justify-center>
          <h1 style="font-size: 10rem;opacity: 0.1;">404</h1>
          <h6 style="position: absolute;background: #EFEFF5;border-radius: 4px;padding: 0px 10px;color: #6d6d6f;">Page not found</h6>
          <div class="home-btn">
            <v-btn type="button" class="AddFlow" outlined block @click="goHome">
              RETURN HOME
            </v-btn>
          </div>
      </v-layout>
    </v-container>
  </template>
  <script>
  export default {
    props: {
      title: {
        type: String,
        default: 'Error'
      },
      message: {
        type: String,
        default: 'An error occurred'
      }
    },
    methods: {
      goHome() {
        this.$router.push('/')
      }
    }
  }
  </script>
  <style scoped>
  
  .home-btn {
    position: absolute;
    top: 60%;
    margin: 10px;
    border-radius: 8px;
  }
.AddFlow:hover {
  color: #ffffff !important;
  background-color: #000;
}

.AddFlow {
  height: 100% !important;
  padding: 10px !important;
  border: 3px dotted #000;
}
  </style>